<opac-user-title [title]="menuTitle() | translate" [skeleton]="(isLoading$ | async) === true"></opac-user-title>

<ng-container *ngIf="(isLoading$ | async) === false">
  <opac-user-section [title]="rankingTitle() | translate" *ngIf="showPoints()">
    <div class="ranking-section">
      <app-gamification-ranking [ranking]="monthlyRanking$ | async" [rankingType]="rankingType.MONTHLY">
      </app-gamification-ranking>
      <app-gamification-ranking [ranking]="generalRanking$ | async" [rankingType]="rankingType.GENERAL">
      </app-gamification-ranking>
    </div>
  </opac-user-section>

  <opac-user-section *ngIf="showBadges()" [title]="'user.ranking.medals.title' | translate">
    <app-gamification-badges></app-gamification-badges>
  </opac-user-section>
</ng-container>

<ng-container *ngIf="(isLoading$ | async) === true">
  <app-gamification-skeleton></app-gamification-skeleton>
  <opac-gradient></opac-gradient>
</ng-container>
